/**
 * Recherches recentes de l'agent, pour que la palette ait quelque chose a
 * montrer avant la premiere frappe.
 *
 * POURQUOI ELLES EXISTENT. La palette s'ouvre sur un champ vide. Sans rien a
 * afficher, l'agent clique et voit un panneau blanc, ce qui est pire qu'un
 * menu deroulant qui ne s'ouvrait pas du tout : il a maintenant l'impression
 * que quelque chose a echoue.
 *
 * LE STOCKAGE DU NAVIGATEUR N'EST PAS FIABLE, ET C'EST LA VRAIE DIFFICULTE DE
 * CE MODULE. Il est refuse en navigation privee, vide apres un effacement de
 * donnees, et l'acces lui-meme peut LEVER au lieu de rendre null. Chaque
 * lecture et chaque ecriture est donc gardee : une navbar qui laisserait
 * passer cette exception casserait TOUS les ecrans de l'application, pour un
 * confort d'affichage. Le contenu peut aussi avoir ete laisse par une autre
 * version, ou par une main humaine : on ne fait donc confiance ni au JSON, ni
 * a son type, ni au type de ses entrees.
 *
 * CE QUI EST GARDE ICI NE SUIT PAS L'AGENT. C'est par navigateur et par poste,
 * jamais partage ni relu par le serveur. C'est acceptable parce qu'il s'agit
 * d'une commodite : rien de ce que porte cette liste n'est necessaire pour
 * chercher.
 */

/** Cle de stockage, exportee pour que les tests puissent semer un contenu abime. */
export const CLE_RECENTES = 'cbconnect.recherche.recentes';

/**
 * Au-dela, la liste cesse d'etre un raccourci et redevient quelque chose a
 * lire : cinq tient dans la palette sans la remplir.
 */
export const MAX_RECENTES = 5;

/**
 * Meme borne que le serveur. Garder un terme plus court proposerait a l'agent
 * de relancer une recherche que le serveur refuserait de faire.
 */
const LONGUEUR_MINIMALE = 3;

function lireBrut() {
  try {
    return window.localStorage.getItem(CLE_RECENTES);
  } catch (e) {
    return null;
  }
}

function ecrireBrut(valeur) {
  try {
    window.localStorage.setItem(CLE_RECENTES, valeur);
  } catch (e) {
    // Rien a faire : la liste est une commodite, son absence n'empeche pas de
    // chercher.
  }
}

/** @returns les termes, du plus recent au plus ancien. Jamais null. */
export function lireRecentes() {
  const brut = lireBrut();
  if (!brut) return [];
  let analyse;
  try {
    analyse = JSON.parse(brut);
  } catch (e) {
    return [];
  }
  if (!Array.isArray(analyse)) return [];
  return analyse.filter((terme) => typeof terme === 'string').slice(0, MAX_RECENTES);
}

/**
 * Place `terme` en tete. Un terme deja present remonte au lieu d'etre
 * duplique, casse et espaces de bord ignores : un agent qui retape « koffi »
 * apres « KOFFI » a cherche la meme chose, et deux lignes pour un seul terme
 * gaspilleraient la moitie de la liste.
 */
export function ajouterRecente(terme) {
  if (typeof terme !== 'string') return;
  const propre = terme.trim();
  if (propre.length < LONGUEUR_MINIMALE) return;

  const normalise = propre.toLowerCase();
  const sansDoublon = lireRecentes().filter((t) => t.trim().toLowerCase() !== normalise);
  ecrireBrut(JSON.stringify([propre, ...sansDoublon].slice(0, MAX_RECENTES)));
}

export function effacerRecentes() {
  try {
    window.localStorage.removeItem(CLE_RECENTES);
  } catch (e) {
    // Meme raison que ecrireBrut.
  }
}
